<script setup lang="ts">
import "./MSpinner.scss";
import { computed } from "vue";
import type { MSpinnerProps } from "./MSpinner.props";
import { mSpinnerDefaults } from "./MSpinner.props";

const props = withDefaults(defineProps<MSpinnerProps>(), mSpinnerDefaults);

const SIZE_KEYWORDS: Record<string, number> = {
  xs: 18,
  sm: 24,
  md: 32,
  lg: 38,
  xl: 46,
};

const cSize = computed(() => {
  const s = props.size;
  if (typeof s === "number") return `${s}px`;
  if (typeof s === "string" && s in SIZE_KEYWORDS) return `${SIZE_KEYWORDS[s]}px`;
  return s as string;
});

const spinnerClasses = computed(() => [
  "m-spinner",
  "m-spinner-mat",
  props.color ? `text-${props.color}` : false,
]);
</script>

<template>
  <svg
    :class="spinnerClasses"
    :width="cSize"
    :height="cSize"
    viewBox="25 25 50 50"
    role="status"
    aria-label="Loading"
  >
    <circle
      class="path"
      cx="50"
      cy="50"
      r="20"
      fill="none"
      stroke="currentColor"
      :stroke-width="thickness"
      stroke-miterlimit="10"
    />
  </svg>
</template>
